import * as React from 'react'
import {useSearchParams} from 'react-router-dom'
import DemoSignup from './iscoutDemoSignup'

export default function Register(): React.ReactElement {
  const [searchParams] = useSearchParams()
  const type = searchParams.get('type')
  switch (type) {
    case 'iscout':
      return (
        <DemoSignup
          src={
            'https://docs.google.com/forms/d/e/1FAIpQLSctwtLdt8BGG712I_8uF7748bsVQVp2NQWKowb86-3gV78CTQ/viewform?embedded=true'
          }
        />
      )
    case 'free':
      return (
        <DemoSignup
          src={
            'https://docs.google.com/forms/d/e/1FAIpQLSeBV0Uy9tAUE67Nab2g-Dn-YY2Vum5aJV-cO_qs-ERUo-_1xQ/viewform?embedded=true'
          }
        />
      )
    case 'hci':
      return (
        <DemoSignup
          src={
            'https://docs.google.com/forms/d/e/1FAIpQLSflK75kSfhxpSk8GEqa3tD0fFsNdV2t5V1QyRWayZ1meKNABw/viewform?embedded=true'
          }
        />
      )
  }
  return <></>
}
